import { createStore } from 'stimulus-store';

/**
 * Store for the complete location hierarchy (regions → buildings → areas → rooms)
 *
 * This store is populated by the all_locales_supplier_controller on page load
 * and provides instant access to the full location tree for the permissions modal.
 *
 * Structure:
 * {
 *   lastRefreshTime: '2024-01-27T10:30:45.123Z',   // ISO timestamp of last successful load
 *   initialLoadComplete: false,                    // true after first successful load
 *   locales: {
 *     regions: [
 *       {
 *         id: 'region-1',
 *         name: 'North Campus',
 *         locale: 'region',
 *         buildings: [
 *           {
 *             id: 'building-1',
 *             name: 'Science Building',
 *             locale: 'building',
 *             areas: [
 *               {
 *                 id: 'area-1',
 *                 name: 'Floor 1',
 *                 locale: 'area',
 *                 rooms: [
 *                   { id: 'room-1', name: 'Room 101', locale: 'room' }
 *                 ]
 *               }
 *             ]
 *           }
 *         ]
 *       }
 *     ]
 *   }
 * }
 */
export const allLocalesStore = createStore({
    name: 'allLocalesStore',
    type: Object,
    initialValue: {
        lastRefreshTime: null,
        regionsLoaded: false,           // true when regions are loaded and can be displayed
        initialLoadComplete: false,     // true when full hierarchy is loaded
        locales: {
            regions: []
        }
    }
});
